import { useEffect } from 'react';

import { useAppDispatch, useAppSelector } from 'store/store-hooks';
import { useLocation } from 'components/_hooks/use-router';
import { setRecentAction } from 'components/app/_mediator/app-logger.slice';
import { setIsAudioPlaying, setIsAudioOn } from '../_mediator/audio-track.slice';
import { useAudioTrackContext } from '../_mediator/audio-track.provider';

export const useWsPlayback = (ws: WaveSurfer) => {
  const { path } = useLocation();
  const { wsPlay } = useAudioTrackContext();
  const { selectedFinalcut, selectedStory } = useAppSelector((state) => state.projects);
  const sbPlayback = useAppSelector((state) => state.sb.sbPlayback);
  const sbWsPlayback = useAppSelector((state) => state.sb.sbWsPlayback);
  const fcPlayback = useAppSelector((state) => state.fc__controls.fcPlayback);
  const dispatch = useAppDispatch();

  const onPlay = () => {
    dispatch(setIsAudioPlaying(true));
  };

  const onPause = () => {
    dispatch(setIsAudioPlaying(false));
  };

  useEffect(() => {
    const val = sbPlayback || sbWsPlayback || fcPlayback;
    dispatch(setRecentAction({ key: 'EVENT', desc: `playback ${val}`, payload: { path } }));
    dispatch(setIsAudioOn(val));
  }, [sbPlayback, sbWsPlayback, fcPlayback]);

  useEffect(() => {
    return () => wsPlay(false);
  }, [path, selectedFinalcut, selectedStory]);

  /* listeners */

  useEffect(() => {
    ws.on('pause', onPause);
    ws.on('play', onPlay);
    return () => {
      ws.un('pause', onPause);
      ws.un('play', onPlay);
    };
  }, []);
};
